// extracted by mini-css-extract-plugin
module.exports = {"switcher":"ThemeSwitcherNav_switcher__a_EWb","light":"ThemeSwitcherNav_light__YamI8","dark":"ThemeSwitcherNav_dark__gYxfY"};